// @flow
import React, { useEffect, useState } from "react";
import { Sticky } from "react-sticky";
import cx from "classnames";

import groceryList from "../../../../assets/images/common/action-grocery-list.svg";
import printPlan from "../../../../assets/images/common/action-printer.svg";
import savePlan from "../../../../assets/images/common/action-save-plan.svg";
import deletePLan from "../../../../assets/images/common/action-delete-plan.svg";
import renamePlan from "../../../../assets/images/common/action-rename-plan.svg";
import PlansDropDown from "../PlansDropDown";

type Props = {
  date: string;
  enableNavigation: boolean;
  navigatePastWeek: React.MouseEventHandler<HTMLButtonElement>;
  navigateNextWeek: React.MouseEventHandler<HTMLButtonElement>;
  hasNext: unknown;
  isCustomPlan: boolean;
  handleKeyPress: unknown;
  saveNewName: unknown;
  gettingGrocery: any;
  savingPlan: any;
  openSavePlanModal: any;
  deletingPlan: any;
  openDeleteModal: any;
  openEditModal: any;
  disableGetPlan: boolean;
  openShoppingCart: () => void;
  openDeliveryPage: () => void;
  savedPlans: any;
  weeklyPlans: any;
  goToPlan: () => void;
  setPlansMenuOpen: () => void;
};

const Header = (props: Props) => {
  const [mobileView, setMobileView] = useState(false);
  useEffect(() => {
    setMobileView(window.innerWidth <= 475);
  });

  const getButtonTitle = () => {
    if (mobileView) {
      return (
        <img
          src={props.isCustomPlan ? renamePlan : savePlan}
          alt="Grocery list"
        />
      );
    }
    let title = "SAVE PLAN";
    if (props.isCustomPlan) {
      title = "RENAME PLAN";
    }
    return <span>{title}</span>;
  };

  return (
    <Sticky>
      {({ style, isSticky }) => (
        <div
          className={cx("meal-header", { sticky: isSticky })}
          style={isSticky ? style : {}}
        >
          <div className="header-container">
            <PlansDropDown
              savedPlans={props.savedPlans}
              weeklyPlans={props.weeklyPlans}
              title={props.date}
              goToPlan={props.goToPlan}
              setPlansMenuOpen={props.setPlansMenuOpen}
            />
          </div>
          <div className="buttons-container">
            <div className="buttons">
              <div className="action-button-container">
                <button
                  className={cx("action-button", {
                    disabled: props.gettingGrocery || props.disableGetPlan
                  })}
                  onClick={props.openShoppingCart}
                >
                  {!mobileView ? (
                    <span>GROCERY LIST</span>
                  ) : (
                    <img src={groceryList} alt="Grocery list" />
                  )}
                </button>
                <button
                  className="action-button"
                  onClick={props.openDeliveryPage}
                >
                  {!mobileView ? (
                    <span>PRINT</span>
                  ) : (
                    <img src={printPlan} alt="Grocery list" />
                  )}
                </button>
                <button
                  className={cx("action-button", {
                    disabled: props.savingPlan
                  })}
                  onClick={
                    props.isCustomPlan
                      ? props.openEditModal
                      : props.openSavePlanModal
                  }
                >
                  {getButtonTitle()}
                </button>

                <button
                  className={cx("action-button", {
                    disabled: props.deletingPlan || !props.isCustomPlan
                  })}
                  onClick={
                    !props.deletingPlan &&
                    props.isCustomPlan &&
                    props.openDeleteModal
                  }
                >
                  {!mobileView ? (
                    <span>DELETE</span>
                  ) : (
                    <img src={deletePLan} alt="Grocery list" />
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Sticky>
  );
};

export default Header;
